import React, { forwardRef, useImperativeHandle } from 'react';
import { Button, LinearProgress, Stack, Typography } from '@mui/material';
import axios from 'axios';
import { FieldNavigationCard, FieldNavigationList, FieldNavigationOption } from '../field/FieldNavigation';
import useToken from '../../services/token';
const SUBSECTIONS = [
    { key: 'techcard', label: 'Заполнить техкарту' },
    { key: 'agrochem', label: 'Заполнить Агрохим' },
];
const FieldSubsectionList = forwardRef((props, ref) => {
    var _a, _b;
    const { parseJwt } = useToken();
    const role = (_b = (_a = parseJwt(props.token)) === null || _a === void 0 ? void 0 : _a.role) !== null && _b !== void 0 ? _b : null;
    const [list, setList] = React.useState([]);
    const [load, setLoad] = React.useState(Boolean(props.token));
    const [loadError, setLoadError] = React.useState(false);
    const requestVersion = React.useRef(0);
    const [expandedId, setExpandedId] = React.useState(null);
    const [current, setCurrent] = React.useState(null);
    const [currentSubsection, setCurrentSubsection] = React.useState(null);
    useImperativeHandle(ref, () => ({ update }));
    const update = () => {
        if (!props.token)
            return;
        const version = ++requestVersion.current;
        setLoad(true);
        setLoadError(false);
        axios.get('/field/list', { headers: { Authorization: `Bearer ${props.token}` } }).then((response) => {
            if (version !== requestVersion.current)
                return;
            if (Array.isArray(response.data)) {
                setList(response.data);
            }
            else
                setLoadError(true);
        }).catch(() => {
            if (version === requestVersion.current)
                setLoadError(true);
        }).finally(() => {
            if (version === requestVersion.current)
                setLoad(false);
        });
    };
    React.useEffect(() => { update(); }, []);
    const toggleField = (item) => {
        const willExpand = expandedId !== item.id;
        setExpandedId(willExpand ? item.id : null);
        if (willExpand && (current === null || current === void 0 ? void 0 : current.id) !== item.id) {
            setCurrent(item);
            setCurrentSubsection(null);
        }
    };
    const chooseSubsection = (item, subsection) => {
        setCurrent(item);
        setCurrentSubsection(subsection);
    };
    React.useEffect(() => {
        props.select(current, currentSubsection);
    }, [current, currentSubsection]);
    return (React.createElement(React.Fragment, null,
        load && React.createElement(LinearProgress, { "data-onboarding-state": "loading", color: "success" }),
        !load && loadError && (React.createElement(Stack, { "data-onboarding-state": "error", alignItems: "center", sx: { pt: 2 } },
            React.createElement(Typography, { variant: "caption", color: "error" }, "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043F\u043E\u043B\u044F."),
            React.createElement(Button, { size: "small", onClick: update }, "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C"))),
        !load && !loadError && list.length === 0 && (React.createElement(Typography, { "data-onboarding-state": "empty", variant: "caption", component: "div", align: "center", sx: { color: 'grey', pt: 2 } }, role === 'Работник' ? 'Ожидается назначение полей' : role === 'user' ? 'Ожидается назначение роли' : 'Список полей пуст')),
        React.createElement(FieldNavigationList, null, list.map((item) => (React.createElement(FieldNavigationCard, { key: item.id, name: item.name, expanded: expandedId === item.id, selected: (current === null || current === void 0 ? void 0 : current.id) === item.id, onToggle: () => toggleField(item) }, SUBSECTIONS.map((s) => (React.createElement(FieldNavigationOption, { key: s.key, selected: (current === null || current === void 0 ? void 0 : current.id) === item.id && currentSubsection === s.key, onClick: () => chooseSubsection(item, s.key) }, s.label)))))))));
});
export default FieldSubsectionList;
